/**
 * External dependencies
 */
import React from "react";
import { map } from "lodash";
import { Box } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */
import ReportListItem from "./report-list-item";

/**
 * Style dependencies
 */
import "./styles.scss";

const ReportListGrid = ({ reports }) => {
  return (
    <Box className="reports__report-list-grid">
      {map(reports, ({ key, ...rest }, index) => {
        return <ReportListItem key={key} {...rest} />;
      })}
    </Box>
  );
};

export default ReportListGrid;
